<template>
    <!-- All / UK / USA / Other tabs with a count on each, as on the admin Servers page -->
    <div class="region-tabs" role="tablist">
        <button v-for="r in REGIONS" :key="r.key" type="button" role="tab" class="region-tab"
            :class="{ 'is-on': modelValue === r.key }" :aria-selected="modelValue === r.key" @click="emit('update:modelValue', r.key)">
            {{ r.label }} <span v-if="counts" class="region-tab__count">{{ counts[r.key] ?? 0 }}</span>
        </button>
    </div>
</template>

<script setup>
import { defineEmits, defineProps } from 'vue';
import { REGIONS } from '@/helpers/region';

defineProps({
    modelValue: { type: String, default: 'all' },
    counts: { type: Object, default: null },     // { all, uk, usa, other }
});
const emit = defineEmits(['update:modelValue']);
</script>

<style scoped>
.region-tabs { display: flex; flex-wrap: wrap; gap: 8px; margin: 4px 0 12px; }
.region-tab { display: inline-flex; align-items: center; gap: 8px; padding: 8px 14px; border: 1px solid var(--ui-line); border-radius: 10px; background: var(--ui-card); color: var(--ui-dim); font-size: 14px; font-weight: 600; cursor: pointer; }
.region-tab:hover, .region-tab:focus-visible { border-color: var(--ui-pri-hover); outline: none; }
.region-tab.is-on { border: 2px solid var(--ui-pri); padding: 7px 13px; background: var(--ui-pri-soft); color: var(--ui-ink); }
.region-tab__count { padding: 1px 8px; border-radius: 999px; background: var(--ui-line); color: var(--ui-ink); font-size: 12px; font-variant-numeric: tabular-nums; }
.region-tab.is-on .region-tab__count { background: var(--ui-pri); color: #ffffff; }
</style>
